/**
 * מוסיף chatUserId לנתיב תצוגת שיחות, תוך שמירה על query (?wf=) אם קיים.
 */
export function appendChatUserToChatViewUrl(viewUrl: string, chatUserId?: string | null): string {
  if (!chatUserId) return viewUrl;
  const qIndex = viewUrl.indexOf('?');
  const pathOnly = qIndex >= 0 ? viewUrl.slice(0, qIndex) : viewUrl;
  const search = qIndex >= 0 ? viewUrl.slice(qIndex) : '';
  return `${pathOnly}/${chatUserId}${search}`;
}

export function getPathnameOnly(url: string): string {
  const q = url.indexOf('?');
  return q >= 0 ? url.slice(0, q) : url;
}
